export const initState = {
  headerHeight: 0,
  bodyHeight: 0,
  ctaHeight: 0,
  totalHeight: 0,
};

export const layoutAction = {
  ON_HEDER_LAYOUT: 'ON_HEDER_LAYOUT',
  ON_BODY_LAYOUT: 'ON_BODY_LAYOUT',
  ON_CTA_LAYOUT: 'ON_CTA_LAYOUT',
};

export const reducer = (state, action) => {
  switch (action.type) {
    case layoutAction.ON_HEDER_LAYOUT:
      state = {
        ...state,
        headerHeight: action.height,
        totalHeight: action.height + state.bodyHeight + state.ctaHeight,
      };
      break;
    case layoutAction.ON_BODY_LAYOUT:
      state = {
        ...state,
        bodyHeight: action.height,
        totalHeight: state.headerHeight + action.height + state.ctaHeight,
      };
      break;
    case layoutAction.ON_CTA_LAYOUT:
      state = {
        ...state,
        ctaHeight: action.height,
        totalHeight: state.headerHeight + state.bodyHeight + action.height,
      };
      break;
  }
  return state;
};
